import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { ActiveCardSubscriptionResponse } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const activeCardSubscriptionKeys = {
  all: () => ['activeCardSubscription'] as const,
  detail: (fetchUrl: string) =>
    [...activeCardSubscriptionKeys.all(), 'detail', fetchUrl] as const,
};

export const activeCardSubscriptionQueries = {
  detail: (fetchUrl: string) =>
    queryOptions({
      queryKey: activeCardSubscriptionKeys.detail(fetchUrl),
      queryFn: () =>
        HttpClient.request<ActiveCardSubscriptionResponse>({
          method: 'GET',
          url: fetchUrl,
        }),
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: true,
      enabled: !!fetchUrl,
    }),
};
